import { Button, Checkbox, Input } from 'antd';
import { FormattedMessage } from 'react-intl';

import ChangePassword from '../../../components/ChangePassword/ChangePassword';
import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';

import { TabStatus } from './UserSettings.model';

import { useUserSettings } from './useUserSettings';

import styles from './UserSettings.module.scss';

const UserSettings = () => {
	const {
		setEmail,
		setOldEmail,
		state,
		toggleEditEmail,
		togglePasswordPopup,
		updateEmail,
		updateSettings,
	} = useUserSettings();
	const {
		contactOptions,
		editEmail,
		email,
		isInvalidEmail,
		showPasswordPopup,
		tabStatus
	} = state;

	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="envelope"
						type="solid"
						color="light"
						width="16px"
						height="16px"
					/>
					<h2>
						<FormattedMessage id="userSettings.email" />
					</h2>
				</div>
				<div className={styles.categoryContent}>
					{!editEmail ? (
						<>
							<p>{email}</p>
							<Button type="link" onClick={toggleEditEmail}>
								<FormattedMessage id="buttons.edit" />
							</Button>
						</>
					) : (
						<>
							<Input
								defaultValue={email}
								onChange={(event) => {
									setEmail(event.target.value);
								}}
							/>
							<div>
								<Button
									type="link"
									onClick={() => {
										updateEmail();
										toggleEditEmail();
									}}
									disabled={isInvalidEmail}
								>
									<FormattedMessage id="buttons.save" />
								</Button>
								<Button
									type="link"
									onClick={() => {
										toggleEditEmail();
										setOldEmail();
									}}
								>
									<FormattedMessage id="buttons.cancel" />
								</Button>
							</div>
						</>
					)}
				</div>
			</div>
			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="lock"
						type="solid"
						color="light"
						width="16px"
						height="16px"
					/>
					<h2>
						<FormattedMessage id="userSettings.password" />
					</h2>
				</div>
				<div className={styles.categoryContent}>
					<Button type="link" onClick={togglePasswordPopup}>
						<FormattedMessage id="buttons.changePassword" />
					</Button>
				</div>
			</div>
			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="eye"
						type="solid"
						color="light"
						width="16px"
						height="16px"
					/>
					<h2>
						<FormattedMessage id="userSettings.contactOptions" />
					</h2>
				</div>
				{contactOptions && (
					<div className={styles.categoryContent}>
						<div className={styles.contactCheckbox}>
							<Checkbox
								className="contactCheckbox"
								name="allowSearch"
								checked={contactOptions?.includeInSearch}
								onChange={(event) => {
									updateSettings({
										...contactOptions,
										includeInSearch: event.target.checked,
									});
								}}
							>
								<FormattedMessage id="userSettings.allowSearch" />
							</Checkbox>
						</div>
						<div className={styles.contactCheckbox}>
							<Checkbox
								className="contactCheckbox"
								name="allowNetwork"
								checked={contactOptions?.includeInNetwork}
								onChange={(event) => {
									updateSettings({
										...contactOptions,
										includeInNetwork: event.target.checked,
									});
								}}
							>
								<FormattedMessage id="userSettings.allowNetwork" />
							</Checkbox>
						</div>
					</div>
				)}
			</div>
			{showPasswordPopup && <ChangePassword onClose={togglePasswordPopup} />}
		</div>

	);
};

export default UserSettings;